const GAME_MODES = {
  GAME_MODE_caverns: 'GAME_MODE_caverns',
  GAME_MODE_pvpAuto: 'GAME_MODE_pvpAuto',
  GAME_MODE_pvpLive: 'GAME_MODE_pvpLive',
};

const SUBMODE_SIZES = [1, 2, 3, 5, 7, 11];

const GAME_SUBMODES = {
  GAME_SUBMODE_pvp1v1: 'GAME_SUBMODE_pvp1v1',
  GAME_SUBMODE_pvp2v2: 'GAME_SUBMODE_pvp2v2',
  GAME_SUBMODE_pvp3v3: 'GAME_SUBMODE_pvp3v3',
  GAME_SUBMODE_pvp5v5: 'GAME_SUBMODE_pvp5v5',
  GAME_SUBMODE_pvp7v7: 'GAME_SUBMODE_pvp7v7',
  GAME_SUBMODE_pvp11v11: 'GAME_SUBMODE_pvp11v11',
  GAME_SUBMODE_caverns1man: 'GAME_SUBMODE_caverns1man',
  GAME_SUBMODE_caverns2man: 'GAME_SUBMODE_caverns2man',
  GAME_SUBMODE_caverns3man: 'GAME_SUBMODE_caverns3man',
  GAME_SUBMODE_caverns5man: 'GAME_SUBMODE_caverns5man',
  GAME_SUBMODE_caverns7man: 'GAME_SUBMODE_caverns7man',
  GAME_SUBMODE_caverns11man: 'GAME_SUBMODE_caverns11man',
};


const ItemQuality = {
  QUALITY_I: 0.2,
  QUALITY_II: 0.4,
  QUALITY_III: 0.6,
  QUALITY_IV: 0.8,
  QUALITY_V: 1.0,
};

const NORTH = 'NORTH';
const SOUTH = 'SOUTH';
const EAST = 'EAST';
const WEST = 'WEST';

const MOVES = {
  NORTH: 0,
  NORTHEAST: 1,
  SOUTHEAST: 2,
  SOUTH: 3,
  SOUTHWEST: 4,
  NORTHWEST: 5,
};

const TILE_ROWS = 23;
const TILE_COLUMNS = 19;

module.exports = {
  GAME_MODES,
  GAME_SUBMODES,
  SUBMODE_SIZES,
  ItemQuality,
  NORTH,
  SOUTH,
  EAST,
  WEST,
  MOVES,
  TILE_ROWS,
  TILE_COLUMNS,
};
